import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { MediaSingleDimensionHelper } from '@atlaskit/editor-common/ui';
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
export var wrapperStyle = function wrapperStyle(props) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t& > div {\n\t\t", ";\n\t\tposition: relative;\n\t\tclear: both;\n\t}\n"])), MediaSingleDimensionHelper(props));
};